(function () {
	'use strict';

	const SCROLL_THRESHOLD = 0.33;
	let scrollToTop = null;
	let isVisible = false;
	let ticking = false;
	let cachedMaxScroll = 0;

	function updateMaxScroll() {
		cachedMaxScroll = document.documentElement.scrollHeight - window.innerHeight;
	}

	function init() {
		scrollToTop = document.querySelector('[data-scroll-to-top]');
		if (!scrollToTop) return;

		const button = scrollToTop.querySelector('button');
		if (button) {
			button.addEventListener('click', handleClick);
		}

		/* Pas de lecture de scrollHeight au chargement (layout force de toute la page,
		   ~70 ms a CPU x4) : mesure au premier defilement, remise a zero au resize. */
		window.addEventListener('scroll', handleScroll, { passive: true });
		window.addEventListener('resize', () => { cachedMaxScroll = 0; }, { passive: true });
		if (window.scrollY > 0) handleScroll();
	}

	function handleScroll() {
		if (ticking) return;
		ticking = true;
		requestAnimationFrame(checkVisibility);
	}

	function checkVisibility() {
		ticking = false;
		if (!cachedMaxScroll) updateMaxScroll();
		const shouldShow = cachedMaxScroll > 0 && (window.scrollY / cachedMaxScroll) >= SCROLL_THRESHOLD;

		if (shouldShow !== isVisible) {
			isVisible = shouldShow;
			scrollToTop.classList.toggle('is-visible', isVisible);
		}
	}

	function handleClick() {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => requestAnimationFrame(init));
	} else {
		requestAnimationFrame(init);
	}
})();
